export default __webpack_public_path__ + "static/media/error_hash.8cd33fd4.svg";